import { Routes, Route, Navigate } from 'react-router-dom';
import { Component, useState, useEffect, type ReactNode } from 'react';
import { Landing } from './pages/Landing';
import { LoginPage } from './pages/LoginPage';
import { AdminLayout } from './layouts/AdminLayout';
import { DashboardPage } from './pages/admin/DashboardPage';
import { UsersPage } from './pages/admin/UsersPage';
import { AuditPage } from './pages/admin/AuditPage';
import { AiLabPage } from './pages/admin/AiLabPage';
import { MockupLabPage } from './pages/admin/MockupLabPage';
import { OzonLabPage } from './pages/admin/OzonLabPage';
import { authService } from './services/auth';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const handler = () => setTick((n) => n + 1);
    window.addEventListener('auth:logout', handler);
    return () => window.removeEventListener('auth:logout', handler);
  }, []);
  if (!authService.isAuthenticated() || !authService.isAdmin()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

class ErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean; error: string }
> {
  state = { hasError: false, error: '' };

  static getDerivedStateFromError(err: Error) {
    return { hasError: true, error: err.message };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-[50vh]">
          <div className="text-center p-8 rounded-xl bg-slate-800/40 border border-red-500/20 max-w-md">
            <p className="text-red-400 font-medium mb-2">Ошибка загрузки</p>
            <p className="text-sm text-slate-500 mb-4">{this.state.error}</p>
            <button
              onClick={() => this.setState({ hasError: false, error: '' })}
              className="px-4 py-2 rounded-lg bg-slate-700 text-slate-300 hover:bg-slate-600 text-sm transition"
            >
              Попробовать снова
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <Routes>
      {/* Главная — лендинг-портфолио (13.10.2026, заменил старую заглушку по «да» владельца). */}
      <Route path="/" element={<Landing />} />
      <Route path="/new" element={<Navigate to="/" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/admin"
        element={
          <RequireAuth>
            <AdminLayout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="audit" element={<AuditPage />} />
        <Route path="ai" element={<ErrorBoundary><AiLabPage /></ErrorBoundary>} />
        <Route path="mockup" element={<ErrorBoundary><MockupLabPage /></ErrorBoundary>} />
        <Route path="ozon" element={<ErrorBoundary><OzonLabPage /></ErrorBoundary>} />
      </Route>
    </Routes>
  );
}
